import { publicRoutes } from '@/src/core/routes';
import { matchPath } from 'react-router-dom-v5';

export function isPublicRoute(pathname: string): boolean {
  return publicRoutes.some(route => {
    const match = matchPath(pathname, {
      path: route.path,
      exact: route.exact ?? false,
    });
    return match !== null;
  });
}
